/* eslint-disable */
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TermsActions } from 'store/slices/Terms&Condition';

// material-ui
import {
    Button,
    CardContent,
    CardActions,
    Divider,
    Grid,
    IconButton,
    Modal,
    Typography,
    Checkbox,
    TextField,
    FormControlLabel
} from '@mui/material';
import { Box } from '@mui/system';
import useAuth from 'hooks/useAuth';
import { openPdfModal } from 'store/slices/pdfViewer';
import TermsPDf from '../../../assets/pdfs/LeaveAggrement.pdf';
import { openSnackbar } from 'store/slices/snackbar';
import { generatePdf } from './TermsPdf';
import { AttachmentActions } from 'store/slices/attachments';

const TermModal = ({ open, setOpen, handleOpen, handleClose, setReqSend }) => {
    const { user } = useAuth();
    const [checked, setChecked] = useState(false);

    const [data, setData] = useState({
        company_name: user?.company?.name,
        address: user?.company?.address,
        phoneNo: user?.company?.phoneNo,
        email: user?.company?.email
    });

    const { createTerms } = TermsActions;
    const { getS3PresignedUrl } = AttachmentActions;

    const dispatch = useDispatch();

    const handleTerms = async () => {
        if (checked && data?.company_name && data?.address && data?.phoneNo && data?.email) {
            const docUrl = await handleDownloadDoc();
            dispatch(createTerms({ ...data, documentUrl: docUrl }))
                .then(() => {
                    handleClose();
                    setReqSend(true);
                })
                .catch(() => enqueueSnackbar('Refresh', { variant: 'error' }));
        } else {
            dispatch(
                openSnackbar({
                    open: true,
                    message: `Please Enter The Property Management Company Details`,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true
                })
            );
        }
    };

    const handleDownload = async () => {
        const file = generatePdf(data?.company_name, data?.address, data?.phoneNo, data?.email, user?.firstName + user?.lastName);
    };

    const handleDownloadDoc = async () => {
        const file = generatePdf(data?.company_name, data?.address, data?.phoneNo, data?.email, user?.firstName + user?.lastName);

        // Upload PDF to AWS S3
        const key = `MLS_Agreement_${Date.now()}.pdf`;
        const s3Url = await dispatch(getS3PresignedUrl(key));

        if (!s3Url?.payload) {
            throw new Error('S3 URL not generated');
        }

        // Upload the file to S3 using the presigned URL
        const response = await fetch(s3Url?.payload, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type // Set the file type
            },
            body: file
        });

        if (!response.ok) {
            throw new Error('Failed to upload to S3');
        }

        // console.log({ response });
        return key;
    };

    return (
        <Grid>
            <Modal
                open={open}
                onClose={handleClose}
                BackdropProps={{
                    onClick: (e) => e.stopPropagation()
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        padding: 5,
                        borderRadius: 1,
                        width: '80%',
                        height: '90%',
                        margin: 'auto',
                        mt: 5,
                        overflowY: 'auto'
                    }}
                >
                    <Typography sx={{ textAlign: 'center', fontWeight: 700 }} variant="h3" gutterBottom>
                        MLS Listings Agreement
                    </Typography>
                    <Grid item xs={12} sx={{ mt: 4 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography
                                    sx={{ fontSize: '1rem', fontWeight: 500, textDecorationLine: 'underline' }}
                                    variant="body1"
                                    gutterBottom
                                >
                                    Listing Brokerage (“Provider”)
                                </Typography>
                                <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                    Brokerage Name: KX Realty PLLC
                                </Typography>
                                <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                    Address: 1433 Lady Grey Ave, 78660
                                </Typography>
                                <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                    Phone: 5123875314
                                </Typography>
                                <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                    Email: khiere@kxrealtypllc.com
                                </Typography>
                                <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                    License Number: #9007836
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography
                                    sx={{ fontSize: '1rem', fontWeight: 500, textDecorationLine: 'underline' }}
                                    variant="body1"
                                    gutterBottom
                                >
                                    Property Management Company (“Client”)
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                        Company Name:
                                    </Typography>
                                    <TextField
                                        sx={{ px: 2 }}
                                        label=""
                                        variant="standard"
                                        value={data?.company_name}
                                        onChange={(e) => {
                                            setData({ ...data, company_name: e.target.value });
                                        }}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                        Address:
                                    </Typography>
                                    <TextField
                                        sx={{ px: 2 }}
                                        label=""
                                        variant="standard"
                                        value={data?.address}
                                        onChange={(e) => {
                                            setData({ ...data, address: e.target.value });
                                        }}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                        Phone:
                                    </Typography>
                                    <TextField
                                        sx={{ px: 2 }}
                                        label=""
                                        variant="standard"
                                        value={data?.phoneNo}
                                        onChange={(e) => {
                                            setData({ ...data, phoneNo: e.target.value });
                                        }}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography sx={{ fontSize: '1rem', fontWeight: 500 }} variant="body1" gutterBottom>
                                        Email:
                                    </Typography>
                                    <TextField
                                        sx={{ px: 2 }}
                                        label=""
                                        variant="standard"
                                        value={data?.email}
                                        onChange={(e) => {
                                            setData({ ...data, email: e.target.value });
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Typography sx={{ fontSize: '0.95rem' }} variant="body1" gutterBottom>
                        <Typography
                            sx={{ pt: 3, fontSize: '1rem', fontWeight: 500, textDecorationLine: 'underline' }}
                            variant="body1"
                            gutterBottom
                        >
                            Terms of Agreement
                        </Typography>
                        <br />
                        <strong>Authorization:</strong> The Client hereby grants the Provider exclusive authorization to create listings on
                        the Multiple Listing Service (“MLS”) associated with the region in which the property or properties that are
                        submitted by the Client are located. Provider will syndicate the listings to external websites unless Client
                        requests otherwise.
                        <br />
                        <br />
                        <strong>Listing Period:</strong> A listing will be active once the Provider posts the listing onto the MLS. A
                        listing will terminate once the unit is rented or once the Client requests to terminate the listing.
                        <br />
                        <br />
                        <strong>Listing Fee:</strong> In consideration for the services rendered, the Client agrees to pay a flat fee of
                        $200.00 per listing per month the listing is active or $100.00 per listing if all available floor plans within the
                        complex are listed. This fee is paid to the Provider within 30 days of the listing date. The Client will be invoiced
                        on a monthly basis.
                        <br />
                        <br />
                        <strong>Property Disclosure:</strong> The Client warrants that they will provide accurate and complete information
                        about the property and disclose any known material defects. Both parties acknowledge that the Client is responsible
                        for ensuring the legality of the units listed.
                        <br />
                        <br />
                        <strong>Termination:</strong> Either party may terminate this agreement for just cause by written agreement with a
                        30 day notice. Upon termination, all obligations and liabilities under this agreement cease.
                        <br />
                        <br />
                        <strong>Cooperating Brokerage:</strong> The Provider agrees to cooperate with other real estate brokerages and share
                        the agreed-upon commission as specified by the Client and MLS rules.
                        <br />
                        <br />
                        <strong>Marketing and Promotion:</strong> The Provider will employ its reasonably best efforts to create MLS
                        listings and syndicate them to external websites for the apartment units.
                        <br />
                        <br />
                        <strong>Price and Availability Changes:</strong> Any changes in the number of listings or their respective
                        information must be submitted in writing or electronically by the Client to the Provider.
                        <br />
                        <br />
                        <strong>Publicity:</strong> Each Party shall have the right to publicly announce the existence of the business
                        relationship between the Parties. Provider may use Client’s name, trademarks, and logos (collectively, “Client’s
                        Marks”) on Provider’s website and in its marketing materials to identify Client as Provider’s customer.
                        <br />
                    </Typography>
                    <Typography sx={{ fontSize: '0.95rem' }} variant="body1" gutterBottom>
                        <Typography
                            sx={{ pt: 3, fontSize: '1rem', fontWeight: 500, textDecorationLine: 'underline' }}
                            variant="body1"
                            gutterBottom
                        >
                            Agreement Acceptance:
                        </Typography>
                        By signing below, the parties acknowledge their understanding and acceptance of the terms and conditions outlined in
                        this Texas Listing Agreement.
                    </Typography>

                    <Grid container alignItems="center" justifyContent="space-between" sx={{ marginTop: 10 }}>
                        <Grid item>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={checked}
                                        onChange={(event) => setChecked(event.target.checked)}
                                        name="checked"
                                        color="primary"
                                    />
                                }
                                label={<Typography variant="subtitle1">Agree with Terms & Condition.</Typography>}
                            />
                        </Grid>

                        <Grid>
                            <Button onClick={handleDownload} variant="contained" color="primary" sx={{ marginRight: 4 }}>
                                Download
                            </Button>
                            <Button onClick={handleTerms} disabled={!checked} variant="contained" color="secondary">
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </Grid>
    );
};

export default TermModal;
